import React from 'react';

const MiniNavbar = () => {
  return (
    <div data-wf--navbar-floating--variant="base" className="navbar_mini_wrap">
      <div className="navbar_mini_contain">
        <button 
          data-wf--btn-contact--variant="base" 
          data-contact-btn="" 
          className="btn_default_wrap"
        >
          <div className="btn_default_contain">
            <div data-link="" className="btn_default_text">상담신청</div>
          </div>
          <div className="g_circle is-light"></div>
        </button>
      </div>
      <button data-link-hover="" data-menu-btn="" className="navbar_mini_btn">
        <div className="navbar_menu_wrap">
          <div data-link="black" className="navbar_menu_innertext u-text-small">MENU</div>
        </div>
      </button>
    </div>
  );
};

export default MiniNavbar;